import { createContext, Dispatch, SetStateAction } from 'react'

import { ChartSizeType, AirPopulationStatusItem } from './index.types'

export type AirPopulationContextType = {
  notShareLocationErr: boolean
  notLoadResultError: string | null
  data: AirPopulationStatusItem | null
  setData: Dispatch<SetStateAction<AirPopulationStatusItem | null>>
  loading: boolean
  firstLoading: boolean
  heading: string
  avatar: string
  disclaimer: string
  size: ChartSizeType
  borderOutsideColor: string
  backgroundChartColor: string
  backgroundColor: string
  selectorZIndex?: number
  selectedValue: string | null
  setSelectedValue: Dispatch<SetStateAction<string | null>>
  onChangeValue: (value: string) => void
  handleClickCurrentLocation: () => void
}

export const AirPopulationContext = createContext<AirPopulationContextType>(
  {} as AirPopulationContextType,
)
